import { z } from 'zod';

const SnsPlatformSchema = z.union([
  z.literal('INSTAGRAM'),
  z.literal('YOUTUBE'),
  z.literal('TWITTER'),
  z.literal('TIKTOK'),
  z.literal('ETC'),
]);

/** API ProfileSchema의 SNS 링크와 동기 */
export const SnsLinkSchema = z.object({
  platform: SnsPlatformSchema,
  url: z.string(),
});

export type SnsLink = z.infer<typeof SnsLinkSchema>;

/** SNS 링크 업데이트 요청 (폼/클라이언트에서 플랫폼을 문자열로 전달) */
export const ServiceSnsLinkSchema = z.object({
  platform: z.string(),
  url: z.string().url(),
});

const CuratorProfileCommonFieldsSchema = z.object({
  nickname: z.string(),
  profileImage: z.string().nullable(),
  shopDescription: z.string().nullable(),
  snsLinks: z.array(SnsLinkSchema),
});

export const GetCuratorProfileBySnsTitleServiceResponseSchema = z
  .discriminatedUnion('isMyShop', [
    CuratorProfileCommonFieldsSchema.extend({
      isMyShop: z.literal(true),
      shopLink: z.string(),
    }),
    CuratorProfileCommonFieldsSchema.extend({
      isMyShop: z.literal(false),
      shopLink: z.null(),
    }),
  ])
  .describe('GetCuratorProfileBySnsTitleServiceResponseSchema');

export const UpdateProfileImageServiceRequestSchema = z
  .object({
    profileImage: z.instanceof(File),
  })
  .describe('UpdateProfileImageServiceRequestSchema');

export const UpdateProfileImageServiceResponseSchema = z
  .object({
    curatorId: z.string(),
    imageUrl: z.string().url(),
  })
  .describe('UpdateProfileImageServiceResponseSchema');

export type UpdateProfileImageServiceRequest = z.infer<
  typeof UpdateProfileImageServiceRequestSchema
>;
export type UpdateProfileImageServiceResponse = z.infer<
  typeof UpdateProfileImageServiceResponseSchema
>;

export const UpdateNicknameServiceRequestSchema = z
  .object({
    nickname: z.string().max(8, '닉네임은 최대 8자까지 가능합니다.'),
  })
  .describe('UpdateNicknameServiceRequestSchema');

export const UpdateNicknameServiceResponseSchema = z
  .object({
    curatorId: z.string(),
    nickname: z.string(),
  })
  .describe('UpdateNicknameServiceResponseSchema');

export type UpdateNicknameServiceRequest = z.infer<typeof UpdateNicknameServiceRequestSchema>;
export type UpdateNicknameServiceResponse = z.infer<typeof UpdateNicknameServiceResponseSchema>;

export const GetNicknameRecommendationServiceResponseSchema = z
  .object({
    nickname: z.string(),
  })
  .describe('GetNicknameRecommendationServiceResponseSchema');

export type GetNicknameRecommendationServiceResponse = z.infer<
  typeof GetNicknameRecommendationServiceResponseSchema
>;

export const GetNicknameAvailableCountServiceResponseSchema = z
  .object({
    maxCount: z.number(),
    remainingCount: z.number(),
  })
  .describe('GetNicknameAvailableCountServiceResponseSchema');

export type GetNicknameAvailableCountServiceResponse = z.infer<
  typeof GetNicknameAvailableCountServiceResponseSchema
>;

export const UpdateSnsLinksServiceRequestSchema = z
  .object({
    snsLinks: z.array(ServiceSnsLinkSchema).min(1).max(2),
  })
  .describe('UpdateSnsLinksServiceRequestSchema');

export const UpdateSnsLinksServiceResponseSchema = z
  .object({
    curatorId: z.string(),
  })
  .describe('UpdateSnsLinksServiceResponseSchema');

export type UpdateSnsLinksServiceRequest = z.infer<typeof UpdateSnsLinksServiceRequestSchema>;
export type UpdateSnsLinksServiceResponse = z.infer<typeof UpdateSnsLinksServiceResponseSchema>;

export const ValidateNicknameServiceRequestSchema = z
  .object({
    nickname: z.string(),
  })
  .describe('ValidateNicknameServiceRequestSchema');

export const ValidateNicknameServiceResponseSchema = z
  .object({
    isValid: z.boolean(),
  })
  .describe('ValidateNicknameServiceResponseSchema');

export type ValidateNicknameServiceRequest = z.infer<typeof ValidateNicknameServiceRequestSchema>;
export type ValidateNicknameServiceResponse = z.infer<typeof ValidateNicknameServiceResponseSchema>;

export const GetCuratorProfileBySnsTitleServiceRequestSchema = z
  .object({
    snsTitle: z.string().min(1, 'SNS 타이틀은 필수입니다.'),
  })
  .describe('GetCuratorProfileBySnsTitleServiceRequestSchema');

export type GetCuratorProfileBySnsTitleServiceRequest = z.infer<
  typeof GetCuratorProfileBySnsTitleServiceRequestSchema
>;
export type GetCuratorProfileBySnsTitleServiceResponse = z.infer<
  typeof GetCuratorProfileBySnsTitleServiceResponseSchema
>;
